module.exports = __webpack_public_path__ + "img/pico-arrow-01.b5e13ae8.svg";